/*
 * @Description:
 * @Date: 2022-09-16 16:58:10
 */
export const WHITE_LIST: Array<string | symbol> = [
  '/main/enterprise-real/enterprise-real-redirect',
  '/market-access-mgmt/pc-register',
  '/market-access-mgmt/pc-submit-material',
  '/market-access-mgmt/pc-status'
];
export const TOKEN_BLACK_LIST: Array<string | symbol> = [];
